import { useEffect, useState } from "react";
import { getCurrentWalletConnected, mintNFT } from "./util/interact.js";

import MintNow from "./parts/mint-now.js";
import MintCountdown from "./parts/mint-countdown.js";

import generative from "./images/generative.gif";

const Minter = (props) => {
  const [walletAddress, setWallet] = useState("");
  const [status, setStatus] = useState("");

  console.log("Your Wallet Address is: " + walletAddress);

  const [mintCount, setMintCount] = useState(1);

  useEffect(() => {
    async function fetchMyAPI() {
      const { address, status } = await getCurrentWalletConnected();

      setWallet(address);
      setStatus(status);

      addWalletListener();
    }

    fetchMyAPI();
  }, []);

  function addWalletListener() {
    if (window.ethereum) {
      window.ethereum.on("accountsChanged", (accounts) => {
        if (accounts.length > 0) {
          setWallet(accounts[0]);
          setStatus(
            "👆🏽 Click into the mint button after entering how many you want."
          );
        } else {
          setWallet("");
          setStatus("🦊 Connect to Metamask using the top right button.");
        }
      });
    } else {
      setStatus(
        <p>
          {" "}
          🦊{" "}
          <a
            target="_blank"
            rel="noreferrer"
            href={`https://metamask.io/download.html`}
          >
            You must install Metamask, a virtual Ethereum wallet, in your
            browser.
          </a>
        </p>
      );
    }
  }

  const onMintPressed = async () => {
    const { success, status } = await mintNFT(mintCount);

    setStatus(status);

    if (success) {
      setMintCount(mintCount);
    }
  };

  return (
    <div className="Hero" id="mint">
      <div className="mint-image">
        <div className="mint-image-inner">
          <img src={generative} alt="Generative Art" />
        </div>
      </div>
      <div className="mint-content">
        <form>
          <h2 className="mint-title">Neural Punk</h2>
          <div className="mint-quantity">
            <MintNow></MintNow>
            <MintCountdown></MintCountdown>
          </div>
          <input
            type="number"
            defaultValue="1"
            onChange={(event) => {
              setMintCount(event.target.value);
            }}
          />
        </form>
        <button id="mintButton" onClick={onMintPressed}>
          Mint Now
        </button>
        <p id="status" style={{ color: "#DF2E2E" }}>
          {status}
        </p>
      </div>
    </div>
  );
};

export default Minter;
